import { Input, Select, TextArea } from "common/InputForm";
import useButtonLoader from "common/UseButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { useState } from "react";
import { editFaqApi } from "services/faq";
import { toastMessage } from "utils/toastMessage";

export const EditFAQModel = ({
  setEditModal,
  editModal,
  faqListHandler,
  inputData,
  setInputData,
  types
}) => {
  const [errors, setErrors] = useState({});
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Edit");

  // Validation function
  const validation = () => {
    let status = true;
    const error = {};

 
    // Title validation
    if (!inputData.title) {
      error["title"] = "Please enter a title";
      status = false;
    }

    // Description validation
    if (!inputData.description) {
      error["description"] = "Please enter a description";
      status = false;
    }

    if (!inputData.orderNumber) {
      error["orderNumber"] = "Please enter a orderNumber";
      status = false;
    }
    setErrors(error);
    return status;
  };

  // OnChange handler for input fields
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value) {
        delete newErrors[name];
      }
      return newErrors;
    });
  };

  // Edit FAQ handler
  const EditFaqHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoaders(true);
      try {
        const formData = new FormData();
        formData.append("faqId", inputData._id);

   
        formData.append("title", inputData.title);
        formData.append("description", inputData.description);
        formData.append("orderNumber", inputData.orderNumber);


        const res = await editFaqApi(inputData._id,formData);
        if (res?.status === 200) {
          toastMessage(res?.data?.message, "success", "editFaq");
          setEditModal(false);
          faqListHandler();
        } else {
          toastMessage(res?.message, "error", "editFaq");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoaders(false);
      }
    }
  };

  return (

    <CustomModal
      className={"add_model"}
      show={editModal}
      handleClose={() => {
        setEditModal(false);
        setErrors({});
      }}
    >
      <h3>Edit FAQ</h3>
      <div className="add_model">
        <div className="form_field_wrap">
       
          {/* Title */}
          <div className="form_field">
            <Input
              className={"form-control input"}
              label={"Question (max 50 characters)"}
              type={"text"}
              value={inputData.title || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 50) { // Allow only if the value is 200 characters or less
                  onChangeHandler(e);
                }
              }}                 placeholder={"Enter Title"}
              name={"title"}
              error={errors?.title}
            />
          </div>
        </div>
        {/* Description */}
        <div className="form_field">
          <TextArea
            label="Answer (max 250 characters)"
            type={"text"}
            value={inputData.description || ""}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 250) { // Allow only if the value is 200 characters or less
                onChangeHandler(e);
              }
            }}            
            placeholder={"Enter Description"}
            name={"description"}
            error={errors?.description}
          />
        </div>
   
      </div>
      <div className="form_field_wrap">
        <div className="form_field">
          <Input
            label="Order Number"
            className={"form-control input"}
            type={"number"}
            value={inputData.orderNumber || ""}
            onChange={onChangeHandler}
            placeholder={"Enter Order Number"}
            name={"orderNumber"}
            error={errors?.orderNumber}
          />
        </div>
      </div>

      <div className="button_wrap">
        <button
          type="button"
          className="button light"
          onClick={() => setEditModal(false)}
        >
          Cancel
        </button>
        <button
          type="button"
          ref={buttonLoaders}
          onClick={EditFaqHandler}
          className="button"
        >
          Submit
        </button>
      </div>
    </CustomModal>
  );
};
